export default {
  meta: {
    title: '集客点',
    url: '/sitemap/gather' // 埋点用，记录所属模块
  },
};
